<span #text class="dr-wrapper" style="border: 1px solid #eee;" [ngClass]="{ 'dr-focus': popupOverlayRef }">
  <span class="dr-icon fa fa-calendar"></span>
  <span class="dr-start-container"><input type="text" (focus)="openPopup($event)" (click)="openPopup($event)" readonly
      [disabled]="disabled" [value]="startFormatFun ? startFormatFun(startDate, rangeDates) : startDate" /></span>
  <span class="dr-divider">-</span>
  <span class="dr-end-container"><input type="text" (focus)="openPopup($event)" (click)="openPopup($event)" readonly
      [disabled]="disabled" [value]="endFormatFun ? endFormatFun(endDate, rangeDates) : endDate" /></span>
</span>
